<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="bannerPosition.id === null">{{ 'NEWBANNERPOSITION' | translate }}</span>
            <span *ngIf="bannerPosition.id !== null">{{ 'EDITBANNERPOSITION' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="bannerPositionForm" id="bannerPositionForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="bannerPositionForm" >
            <input type="hidden" name="id" id="bannerPositionId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerPositionName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="bannerPositionName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerPositionForm.controls['name'].invalid && (bannerPositionForm.controls['name'].dirty || bannerPositionForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerPositionForm.controls['name'].errors !== null">
                  <div *ngIf="bannerPositionForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerPositionSlug" formControlName="slug" type="text" pInputText [required]="true"> 
                      <label for="bannerPositionSlug" class="req">{{ 'SLUG' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerPositionForm.controls['slug'].invalid && (bannerPositionForm.controls['slug'].dirty || bannerPositionForm.controls['slug'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerPositionForm.controls['slug'].errors !== null">
                  <div *ngIf="bannerPositionForm.controls['slug'].errors.required">
                   {{ 'SLUGREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-sort-numeric-asc "></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerPositionItemsNumber" formControlName="itemsNumber" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="bannerPositionItemsNumber" class="req">{{ 'ITEMSNUMBER' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerPositionForm.controls['itemsNumber'].invalid && (bannerPositionForm.controls['itemsNumber'].dirty || bannerPositionForm.controls['itemsNumber'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerPositionForm.controls['itemsNumber'].errors !== null">
                  <div *ngIf="bannerPositionForm.controls['itemsNumber'].errors.required">
                   {{ 'ITEMSNUMBERREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-alarm-clock"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerPositionDisplayTime" formControlName="displayTime" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="bannerPositionDisplayTime" class="req">{{ 'DISPLAYTIME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerPositionForm.controls['displayTime'].invalid && (bannerPositionForm.controls['displayTime'].dirty || bannerPositionForm.controls['displayTime'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerPositionForm.controls['displayTime'].errors !== null">
                  <div *ngIf="bannerPositionForm.controls['displayTime'].errors.required">
                   {{ 'DISPLAYTIMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="bannerPositionIsFullScreen" formControlName="isFullScreen" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="bannerPositionIsFullScreen" class="p-d-inline-block p-ml-2 req">{{ 'ISFULLSCREEN' | translate }}</label>
                </div>
                <div *ngIf="bannerPositionForm.controls['isFullScreen'].invalid && (bannerPositionForm.controls['isFullScreen'].dirty || bannerPositionForm.controls['isFullScreen'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerPositionForm.controls['isFullScreen'].errors !== null">
                  <div *ngIf="bannerPositionForm.controls['isFullScreen'].errors.required">
                   {{ 'ISFULLSCREENREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="bannerPositionDisplayOneTime" formControlName="displayOneTime" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="bannerPositionDisplayOneTime" class="p-d-inline-block p-ml-2 req">{{ 'DISPLAYONETIME' | translate }}</label>
                </div>
                <div *ngIf="bannerPositionForm.controls['displayOneTime'].invalid && (bannerPositionForm.controls['displayOneTime'].dirty || bannerPositionForm.controls['displayOneTime'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerPositionForm.controls['displayOneTime'].errors !== null">
                  <div *ngIf="bannerPositionForm.controls['displayOneTime'].errors.required">
                   {{ 'DISPLAYONETIMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="bannerPositionIsPublished" formControlName="isPublished" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="bannerPositionIsPublished" class="p-d-inline-block p-ml-2 req">{{ 'ISPUBLISHED' | translate }}</label>
                </div>
                <div *ngIf="bannerPositionForm.controls['isPublished'].invalid && (bannerPositionForm.controls['isPublished'].dirty || bannerPositionForm.controls['isPublished'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerPositionForm.controls['isPublished'].errors !== null">
                  <div *ngIf="bannerPositionForm.controls['isPublished'].errors.required">
                   {{ 'ISPUBLISHEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKBANNERPOSITIONS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="bannerPosition.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!bannerPositionForm.valid || disableSubmit"> <!--  [disabled]="bannerPositionForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!bannerPositionForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

